import React from "react";
import { useState, useEffect, useRef } from "react";
import LoadingBar from "react-top-loading-bar";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import Image2PdfImagesListScreen from "./Image2PdfImagesListScreen";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";

function Image2PdfMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "Convert PNG, WEBP, SVG, BMP, JPEG, JPG to PDF",
  };
  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/image_to_pdf", title: "Image to PDF" },
    data2: { link: "/image_to_pdf", title: "PNG to PDF" },
    data3: { link: "/image_to_pdf", title: "Photo to PDF online" },
  };

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Convert images to PDF online instantly. Turn JPG, PNG, or photos into high quality PDFs quickly with our fast and secure image to PDF converter."
      ></meta>
      <meta
        name="keywords"
        content="image to pdf, image to pdf converter, convert image to pdf, jpg to pdf, png to pdf, photo to pdf, images to pdf online, online image to pdf, picture to pdf, image pdf converter, convert photos to pdf, image to pdf tool, image to pdf free, pdf creator from images, photo pdf maker"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <Image2PdfImagesListScreen title={title}></Image2PdfImagesListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{
              "image/jpeg": [".jpg", ".jpeg"],
              "image/png": [".png"],
              "image/webp": [".webp"],
              "image/bmp": [".bmp"],
              "image/svg+sml": [".svg"],
            }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our offline Image to PDF, WEBP to PDF, SVG to PDF, BMP to PDF, JPEG to PDF, JPG to PDF and PNG to PDF Converter is a secure, high-performance solution designed for users who need fast and reliable image conversion without an internet connection. This powerful offline image to PDF converter allows you to easily convert WEBP, JPG, JPEG, PNG, BMP, and TIFF images into high-quality PDF files while maintaining original resolution and formatting. Ideal for professionals, students, and businesses, a JPG to PDF converter offline and PNG to PDF converter offline ensures complete data privacy, making it perfect for handling sensitive documents, scanned files, photos, receipts, and reports. With features such as batch image conversion, adjustable page size and orientation, image compression, drag-and-drop support, and multi-image merging into a single PDF, this free offline image to PDF converter delivers maximum efficiency and productivity. Unlike online tools, an offline photo to PDF converter works seamlessly on desktop and mobile devices without uploads or cloud storage, offering faster processing and full control over your files. Whether you need to convert images to PDF for printing, archiving, or sharing, this JPG, PNG to PDF converter offline is an essential document management tool that provides secure, accurate, and high-quality image to PDF conversion offline for everyday and professional use." />
          {/* How to use define max 4 steps */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Convert",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Image to PDF converter"
            why_use={[
              {
                title: "Universal and Standard File Format",
                description:
                  "Our image to PDF converter helps create PDF files that work smoothly on all devices and operating systems, making JPG to PDF and PNG to PDF conversion ideal for universal file sharing.",
              },
              {
                title: "Better File Organization",
                description:
                  "Using an image to PDF converter offline or online, you can combine multiple JPEG, WEBP, SVG, BMP, JPG and PNG images into a single PDF for improved document management and easy storage.",
              },
              {
                title: "Professional Document Presentation",
                description:
                  "This JPG to PDF converter transforms images into clean, professional-looking PDF documents suitable for business, office work, and academic submissions.",
              },

              {
                title: "Easy Sharing and Printing",
                description:
                  "PDFs generated using a PNG to PDF converter maintain layout and quality, ensuring perfect results when printing or sharing via email and cloud platforms.",
              },
              {
                title: "Supports Multiple Image Formats",
                description:
                  "Our powerful image to PDF converter supports JPG, JPEG, PNG, BMP, WEBP, SVG and other formats, making photo to PDF conversion quick and hassle-free.",
              },
              {
                title: "Reduced File Size and Optimization",
                description:
                  "Our free image to PDF converter can compress images efficiently, reducing PDF file size while preserving image clarity for faster uploads and downloads.",
              },
              {
                title: "Improved Security and Privacy",
                description:
                  "PDF files created using a WEBP, BMP, SVG, JPG, PNG to PDF converter can be password-protected, offering better security than standard image files.",
              },
              {
                title: "Offline Conversion Capability",
                description:
                  "This offline image to PDF converter allows users to convert JPG to PDF and PNG to PDF without internet access, ensuring data privacy and faster processing.",
              },
              {
                title: "Perfect for Scanned Documents and Photos",
                description:
                  "Our photo to PDF converter is ideal for converting scanned images, receipts, invoices, and documents into searchable, shareable PDF files.",
              },
            ]}
          />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1599994703}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default Image2PdfMain;
